
export class HhsgSharedClientApplication {
	id: number;
	clientId: number;
	applicationId: number;
	applicationName: string;
	applicationAbbreviation: string;
	createdDate: Date;
	isActive: boolean;
	isPurchased: boolean;
	accessTokenLifetime: number;
	identityTokenLifetime: number;
	childApplicationClientId: number;
	awsMarketplaceProductCode: string;
	awsMarketplaceCustomerId: string;
	fileImportTask: string;
	hasChildApplicationLoginPermission: boolean;
}
